/* Klout — reveal-on-scroll reutilizable. Cualquier elemento con la clase
   .klout-reveal aparece con un fade-up al entrar en viewport (IntersectionObserver).
   Respeta prefers-reduced-motion y soporta el editor de temas. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) && !reduce
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' })
    : null;

  function arm(root) {
    var els = (root || document).querySelectorAll('.klout-reveal');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.kr) return;
      el.dataset.kr = '1';
      if (!io) { el.classList.add('is-in'); return; }
      el.classList.add('klout-reveal--armed');
      var idx = 0;
      if (el.parentElement) {
        var sibs = el.parentElement.querySelectorAll(':scope > .klout-reveal');
        idx = Array.prototype.indexOf.call(sibs, el);
      }
      el.style.transitionDelay = (Math.min(idx < 0 ? 0 : idx, 6) * 0.07) + 's';
      io.observe(el);
    });
  }

  function run() { arm(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
